<template>
  <div class="ad-wrapper">
    <adsbygoogle :ad-style="gadStyle" ad-slot="6544022895" ad-format="" />
    <a href="https://www.kokuchpro.com/" target="_blank">
      <img
        src="/images/kokuchpro_banner.png"
        alt="こくちーずプロ（告知'sプロ）"
      />
    </a>
  </div>
</template>

<script>
export default {
  data: () => ({
    gadStyle: {
      display: 'inline-block',
      width: '300px',
      height: '250px',
      marginBottom: '20px'
    }
  })
}
</script>
